import axios, { endpoints } from '../utils/axios';
import { setSession } from '../auth/context/utils';
import { paths } from '../routes/paths';

const interceptorCorrect = (response) => response;
// eslint-disable-next-line consistent-return
const interceptorError = async (error) => {
  if (error.response?.status === 402 || error.response?.status === 401) {
    sessionStorage.setItem('redirected', true);
    sessionStorage.setItem('redirectMessage', error.response?.data.error);
    sessionStorage.setItem('redirectSeverity', 'error');
    await setSession();
    /* eslint-disable no-restricted-globals */
    window.location.href = paths.auth.login;
  } else if (error.response?.status === 501) {
    //
  } else {
    return Promise.reject(error);
  }
};

class FinancialService {
  static axiosInstance;

  static createAxios = () => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    console.log('Creating axios instance for financial service with user:', user);
    FinancialService.axiosInstance = axios.create({
      withCredentials: true,
      headers: {
        ...axios.defaults.headers,
        User: user || '',
      },
    });

    FinancialService.axiosInstance.interceptors.response.use(interceptorCorrect, interceptorError);

    return FinancialService.axiosInstance;
  };

  static async getData(formData) {
    const axiosInstance = this.createAxios();
    const endpoint = endpoints.api.financial.getData;
    const response = await axiosInstance.post(endpoint,formData);
    return response.data;
  }

  static async getProfile(json) {
    const axiosInstance = this.createAxios();
    const endpoint = endpoints.api.financial.getProfile;
    const response = await axiosInstance.post(endpoint,json);
    return response.data;
  }
}

export default FinancialService;
